import { configureStore } from '@reduxjs/toolkit';

import app from './app';
import domains from './domains';
import {
  user, account, accounts, timezones, linkolnDomains, linkolnEmails,
  previewCards, shortLinkolns, linkViews, cart, integrations,
} from './resources';

const store = configureStore({
  reducer: {
    app,
    domains,
    user,
    account,
    accounts,
    timezones,
    linkolnDomains,
    linkolnEmails,
    previewCards,
    shortLinkolns,
    linkViews,
    cart,
    integrations,
  },
});

export default store;
